import { JogetClient } from "../Data/jogetClient";

export const getSignatures = ({ pageSize }) => {
  if (!pageSize) pageSize = 150;

  return JogetClient.get(import.meta.env.VITE_API_SIGNATURES, {
    params: { pageSize },
  });
};
